export const testimonialsContent = {
  sectionLabel: "Client Testimonials",
  title: "Real Stories of Growth, Efficiency, and Results",
  button: "View All Success Stories",
  buttonHref: "/success-stories",

  // Lista completa de testimonios
  allTestimonials: [
    {
      video: {
        title: "Micheal Magers on Time Freedom",
        wistiaId: "c9c4wbk6cu",
      },
      text: {
        author: "Michael Magers",
        role: "Heavy Civil Contractor",
        quotes:
          "They are a part of our team. I've been working with Nathan for a very long time, and he knows our company. He knows what we're looking for inside and out. They've been able to deliver results that have allowed me to not be in the office and having to do so much work myself.",
      },
    },
    {
      video: {
        title: "Katie Rhodes on Record Profits",
        wistiaId: "depi4llggg",
      },
      text: {
        author: "Katie Rhodes",
        role: "Heavy Civil Contractor",
        quotes:
          "In our first year of working with Hungerford Consulting, we were able to earn more profit than any year in the last 20 years of business",
      },
    },
    {
      video: {
        title: "Carson Wedel on Operations Manager",
        wistiaId: "vcmi2ybjg8",
      },
      text: {
        author: "Carson Wedel",
        role: "Heavy Civil Contractor",
        quotes: `So we've been working with Hungerford Consulting now for three going on four years. Their our experience with their team has been outstanding. The amount of projects that we've been able to get in and do and estimate has been something that we wouldn't been able to do without them. We've estimated about twenty four million dollars worth of projects and and landed about five point five million. To me that speaks for itself. Just get these guys on your team.`,
      },
    },
    {
      video: {
        title: "Blake Enloe on Systems & Time",
        wistiaId: "dm4bytc8lj",
      },
      text: {
        author: "Blake Enloe",
        role: "Heavy Civil Contractor",
        quotes:
          "Definitely helped us get to where we need to be, Daniel was very instrumental...",
      },
    },
    {
      video: {
        title: "Fletch Smith on Delegation & Growth",
        wistiaId: "rczsmo2ngb",
      },
      text: {
        author: "Fletch Smith",
        role: "Developer / Home Builder",
        quotes:
          "I highly recommend Dan when you are at that pinnacle, and you can't do anything more because there is just not enough of you to do it all.",
      },
    },
    {
      video: {
        title: "Scott Callenius on Revenue Breakthrough",
        wistiaId: "i2bpyhucct",
      },
      text: {
        author: "Scott Callenius",
        role: "Landscape Contractor",
        quotes:
          "We weren't able to go past $1M for 20 years. Now, we're doing over $2M+ this year and probably reach $3M+ next year.",
      },
    },
    {
      video: {
        title: "John Foreseth on Systems & Time",
        wistiaId: "1kbzwee64k",
      },
      text: {
        author: "John Foreseth",
        role: "Concrete Contractor",
        quotes:
          "I was doing everything and found myself working longer and longer hours. Hungerford Consulting was able to pull the business out of me, and turn it into a system and process.",
      },
    },
    {
      video: {
        title: "Chris Mcmanus on Doubling Revenue",
        wistiaId: "m1c38rb823",
      },
      text: {
        author: "Chris Mcmanus",
        role: "Landscape Contractor",
        quotes:
          "The system was easy to setup and it allowed us to double our revenue the same year! Working with Dan was one of the best things we did this year.",
      },
    },
    {
      video: {
        title: "Connor Prendergast on Scaling Up",
        wistiaId: "klqgrammv2",
      },
      text: {
        author: "Connor Prendergast",
        role: "Concrete & Landscape Contractor",
        quotes:
          "We've grown from a $3M company to a $6M+ company because of their help.",
      },
    },
    {
      video: {
        title: "Stuart Kriegier on Idea Realized",
        wistiaId: "wbl4sa1282",
      },
      text: {
        author: "Stuart Kriegier",
        role: "Home Builder",
        quotes:
          "I talked to Dan and he pulled the business out of my head. We really appreciate Hungerford Consulting and highly recommend them",
      },
    },
  ],
};
